import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-label__content" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 0,
  class: "form-label__content__optional"
}
const _hoisted_4 = {
  key: 1,
  class: "form-label__content__required"
}

import { Label as KLabel } from '@progress/kendo-vue-labels';
import hint from '@/components/common/hint/Hint.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormLabel',
  props: {
    id: { default: undefined },
    inputId: { default: undefined },
    labelText: {},
    optionalText: { default: undefined },
    hintText: { default: undefined },
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    isValid: { type: Boolean, default: true },
    size: { default: 'medium' },
    behavior: { default: 'fill' }
  },
  setup(__props: any) {

const props = __props;

const state = computed<'disabled' | 'invalid' | 'normal'>(() => {
  if (props.isDisabled) {
    return 'disabled';
  } else if (!props.isValid) {
    return 'invalid';
  } else {
    return 'normal';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KLabel), {
    id: __props.id,
    "editor-id": __props.inputId,
    class: _normalizeClass([
      'form-label',
      `form-label--${__props.size}`,
      `form-label--${state.value}`,
      `form-label--${__props.behavior}`,
    ])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", {
          class: "form-label__content__text",
          textContent: _toDisplayString(__props.labelText)
        }, null, 8, _hoisted_2),
        (__props.optionalText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(__props.optionalText) + ") ", 1))
          : _createCommentVNode("", true),
        (__props.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "* "))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "label-after")
      ]),
      (__props.hintText)
        ? (_openBlock(), _createBlock(hint, {
            key: 0,
            "help-text": __props.hintText
          }, null, 8, ["help-text"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "label-end")
    ]),
    _: 3
  }, 8, ["id", "editor-id", "class"]))
}
}

})